import { Grid, Text } from '@mantine/core';
import { EditableField } from '@/components/EditableField';
import { ORBIT_DISABLED, ORBIT_GRAY } from '@/theme/colors';

interface PanelTextRowProps {
  label: string;
  /** What is stored; the input starts from it. */
  value: string | undefined;
  /** What the row reads while not editing ("Not provided" when nothing is stored, say). */
  display: string;
  /** Faint, for a `display` that says nothing is on file. */
  muted?: boolean;
  /** Called with the trimmed text, empty to clear. Rejects if the write fails; the row stays open. */
  onSave: (value: string) => Promise<void>;
  /** On the input, for tests. */
  testId?: string;
}

/**
 * An editable label-value row in `PanelSelectRow`'s layout: `EditableField` (click, type, Enter
 * or click away to save, Escape to cancel; an unchanged value saves nothing) in the panel's 3/9
 * grid and type.
 */
export function PanelTextRow({ label, value, display, muted, onSave, testId }: PanelTextRowProps) {
  return (
    <Grid align="flex-start" style={{ width: '100%' }}>
      <Grid.Col span={3}>
        <Text style={{ fontSize: 13, lineHeight: '16px', color: ORBIT_GRAY }}>{label}</Text>
      </Grid.Col>
      <Grid.Col span={9}>
        <EditableField
          value={value ?? ''}
          displayValue={display}
          onSubmit={onSave}
          textProps={{
            style: { fontSize: 14, lineHeight: '20px', color: muted ? ORBIT_DISABLED : 'var(--mantine-color-black)' },
          }}
          inputProps={{
            'aria-label': label,
            size: 'xs',
            radius: 'md',
            styles: { input: { height: 20, minHeight: 20, fontSize: 13 } },
            ...(testId ? { 'data-testid': testId } : {}),
          }}
        />
      </Grid.Col>
    </Grid>
  );
}
